import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/legalData";

export default function AITransparency() {
  return (
    <LegalLayout title="Trasparenza AI Act" slug="/trasparenza-ai">
      <p className="lead">
        La presente informativa è resa ai sensi del <b>Regolamento (UE) 2024/1689</b> ("AI Act"), entrato in vigore il 1° agosto 2024, allo scopo di fornire piena trasparenza sull'eventuale utilizzo di sistemi di intelligenza artificiale all'interno della Piattaforma {COMPANY.brand}.
      </p>

      <h2>1. Sintesi (TL;DR)</h2>
      <div className="callout callout-info">
        <p><b>La Piattaforma {COMPANY.brand} (versione MVP v1) NON utilizza sistemi di intelligenza artificiale, machine learning, modelli linguistici di grandi dimensioni (LLM), riconoscimento facciale, OCR automatizzato, classificazione automatica delle immagini, scoring algoritmico né alcuna forma di decisione automatizzata individuale.</b></p>
        <p>Tutte le attività di valutazione, gestione e decisione sulle pratiche di sinistro sono eseguite da <b>operatori umani</b> (i Consulenti).</p>
      </div>

      <h2>2. Funzionalità esaminate</h2>
      <table>
        <thead>
          <tr><th>Funzionalità</th><th>Tecnologia utilizzata</th><th>Sistema AI?</th></tr>
        </thead>
        <tbody>
          <tr><td>Upload e archiviazione foto/video/audio</td><td>Object Storage — nessuna analisi automatica del contenuto</td><td>❌ No</td></tr>
          <tr><td>Geolocalizzazione GPS</td><td>API HTML5 Geolocation del browser dell'utente</td><td>❌ No</td></tr>
          <tr><td>Generazione codice pratica (GS-XXXXXX)</td><td>Contatore numerico atomico</td><td>❌ No</td></tr>
          <tr><td>Invio email transazionali (OTP, notifiche, conferma firma)</td><td>Template statici + Resend (servizio email)</td><td>❌ No</td></tr>
          <tr><td>Generazione PDF impaginato e ZIP archivio</td><td>Librerie open source di rendering (ReportLab, zipfile)</td><td>❌ No</td></tr>
          <tr><td>Generazione QR code consulente</td><td>Algoritmo deterministico di codifica</td><td>❌ No</td></tr>
          <tr><td>Cambio stato pratica</td><td>Azione manuale del Consulente</td><td>❌ No</td></tr>
          <tr><td>Decisione su accettare/rigettare un sinistro</td><td>Esclusivamente umana, eseguita dal Consulente</td><td>❌ No</td></tr>
        </tbody>
      </table>

      <h2>3. Trasparenza sui contenuti generati</h2>
      <p>
        I contenuti pubblicati sulla Piattaforma (testi delle pagine pubbliche, template email, layout PDF) sono stati redatti da {COMPANY.legal_name} con eventuale assistenza redazionale di strumenti generativi di terze parti. Tale uso non rientra nella nozione di "<i>deep fake</i>" o "<i>contenuto manipolato</i>" ai sensi dell'art. 50 dell'AI Act.
      </p>
      <p>
        I contenuti caricati dagli utenti (foto, video, audio, testi) <b>non sono generati né modificati da AI</b> da parte della Piattaforma. La Piattaforma li archivia e trasmette nello stato originale fornito dall'utente.
      </p>

      <h2>4. Assenza di processi decisionali automatizzati</h2>
      <p>
        Ai sensi dell'art. 22 del GDPR e dell'AI Act, si conferma che <b>nessuna decisione individuale automatizzata, profilazione o scoring algoritmico</b> viene effettuata dalla Piattaforma sulla persona dell'Interessato. Il Consulente, persona fisica iscritta agli albi professionali ove richiesto, è l'unico soggetto che valuta, gestisce e decide sulle pratiche.
      </p>

      <h2>5. Evoluzione futura della Piattaforma</h2>
      <p>
        {COMPANY.legal_name} potrà introdurre, in versioni future della Piattaforma, funzionalità basate su intelligenza artificiale finalizzate a migliorare il servizio (a titolo esemplificativo: riconoscimento automatico della targa nelle foto, suggerimento descrizioni del sinistro, classificazione tipologia danno). Qualora ciò avvenga:
      </p>
      <ul>
        <li>La presente informativa sarà <b>aggiornata preventivamente</b>;</li>
        <li>Sarà indicato chiaramente il fornitore del sistema AI, la sua categoria di rischio ai sensi dell'AI Act, le finalità del trattamento;</li>
        <li>L'utente sarà informato in modo chiaro e potrà esercitare i propri diritti (incluso il diritto di richiedere l'intervento umano e di contestare la decisione, ex art. 22 GDPR);</li>
        <li>Se previsto dalla normativa, sarà raccolto un <b>consenso specifico</b>;</li>
        <li>Sarà effettuata una <b>Valutazione d'Impatto sulla Protezione dei Dati (DPIA)</b> ex art. 35 GDPR.</li>
      </ul>

      <h2>6. Sistemi AI vietati</h2>
      <p>
        {COMPANY.legal_name} si impegna a non implementare, ora né in futuro, sistemi di intelligenza artificiale rientranti nelle <b>pratiche vietate</b> ai sensi dell'art. 5 dell'AI Act, tra cui sistemi di:
      </p>
      <ul>
        <li>Manipolazione comportamentale subliminale o sfruttamento di vulnerabilità</li>
        <li>Social scoring per finalità generali</li>
        <li>Riconoscimento delle emozioni in contesti lavorativi o scolastici (non applicabile alla nostra piattaforma)</li>
        <li>Categorizzazione biometrica per inferire dati sensibili</li>
        <li>Identificazione biometrica remota in tempo reale in spazi pubblici</li>
      </ul>

      <h2>7. Contatti</h2>
      <p>Per richieste relative all'impiego di sistemi AI nella Piattaforma:</p>
      <ul>
        <li><b>Email Privacy</b>: <a href={`mailto:${COMPANY.privacy_email}`}>{COMPANY.privacy_email}</a></li>
        <li><b>PEC</b>: <a href={`mailto:${COMPANY.pec}`}>{COMPANY.pec}</a></li>
      </ul>
    </LegalLayout>
  );
}
